<template>
    <v-form ref="form" v-model="valid">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-autocomplete
                        v-model="facilities"
                        :items="items"
                        outlined
                        chips
                        deletable-chips
                        small-chips
                        label="Facilidades do Hotel"
                        multiple
                    ></v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6" offset-md="3">
                    <v-btn
                        depressed
                        color="success"
                        @click="validate"
                        class="w-100"
                    >
                        Proximo
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
export default {
    name: "Facilities",
    props: {
        hotelAmenities: {
            type: Array,
        }
    },
    data: () => ({
        valid: false,
        items: ["Academia", "Aceita animais de estimação", "Café da Manhã", "Estacionamento", "Lavanderia", "Piscina", "Play-ground", "Restaurante", "Wifi"],
        facilities: []
    }),
    methods: {
        validate() {
            this.$refs.form.validate();
            if(this.valid) {
                this.$emit('goToTab', 'rooms');
            }
        },
        getData() {
            return this.facilities;
        },
        setData(){
            for(let i = 0; i < this.hotelAmenities.length; i++){
                this.facilities.push(this.hotelAmenities[i]);
            }
        }
    },
    mounted(){
        if(this.hotelAmenities !== null){
            this.setData();
        }
    }
}
</script>

<style scoped>

</style>
